import { toast } from "sonner";

/**
 * Tell the user a new version is ready, and let them decide when.
 *
 * Deliberately not automatic. Reloading underneath someone who is halfway
 * through a message loses what they were typing, and this app is one people
 * leave open. So it asks, it does not expire on its own, and it stays out of
 * the way until it is answered.
 */
export function showUpdatePrompt(applyUpdate, notify = toast) {
  notify("A new version of Novamund is ready.", {
    description: "Reload to start using it.",
    duration: Infinity,
    action: {
      label: "Reload",
      onClick: applyUpdate,
    },
  });
}
